/* eslint-disable */
import { Row } from 'react-bootstrap';
import '../../components/buttons/mainBtn.css';
import { useTranslation } from 'react-i18next';
import ErrorPage from '../errorPage/ErrorPage';
import Spinner from '../../components/loaders/globalSpinner/Spinner';
import MemoizedStationCard from '../../components/MemoizedStationCard';
import VirtualizedStationList from '../../components/VirtualizedStationList';
import { api, useGetBloodyLitersSavedQuery } from '../../redux/api';
import { useEffect, useLayoutEffect, useState, useCallback, useMemo, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { getGeolocationWithPermission } from '../../hookServices/getGeolocationWithPermission';
import { HOST, PORT } from '../../environment';
import './HomePage.css';
import '../b2bPage/b2bPage.css';
import { getCookie } from '../../hookServices/cookiesManager';
import { SeoHead } from '../../components/SeoHead';

import Box from '@mui/material/Box';
import { Button } from '@ui';
import GlobalChargeImpactSummary from '../../components/GlobalChargeImpactSummary/GlobalChargeImpactSummary';
import StationListSearch from './StationListSearch';
import { filterStationsBySearch, isKm220ListStation } from './stationListSearchUtils';
import { isCapacitorIos } from '../../utils/iosInputZoom';

// SEO configuration for station list page - competitor targeting
const seoConfig = {
  title: 'Список зарядних станцій для електромобілів | Мережа 220 км - Альтернатива Toka, Ecofactor, Go2You',
  description:
    'Повний список зарядних станцій мережі 220 км по всій Україні. Дізнайтесь які станції працюють при блекауті та де є світло. Знайдіть найближчу зарядку для електромобіля. AC та DC станції з реальним статусом онлайн.',
  keywords: [
    // Brand
    'мережа 220 км',
    'мережа 220',
    '220-km',
    'список зарядних станцій',
    // Competitor keywords
    'тока зарядні станції',
    'toka stations',
    'екофактор станції',
    'ecofactor stations',
    'готую станції',
    'go2you stations',
    'альтернатива toka',
    'альтернатива екофактор',
    // City keywords - all major Ukrainian cities
    'зарядні станції Київ',
    'зарядні станції Харків',
    'зарядні станції Одеса',
    'зарядні станції Дніпро',
    'зарядні станції Львів',
    'зарядні станції Запоріжжя',
    'зарядні станції Вінниця',
    'зарядні станції Полтава',
    'зарядні станції Чернігів',
    'зарядні станції Черкаси',
    'зарядні станції Житомир',
    'зарядні станції Суми',
    'зарядні станції Хмельницький',
    'зарядні станції Чернівці',
    'зарядні станції Рівне',
    'зарядні станції Івано-Франківськ',
    'зарядні станції Тернопіль',
    'зарядні станції Луцьк',
    'зарядні станції Ужгород',
    'зарядні станції Кропивницький',
    'зарядні станції Умань',
    'зарядні станції Біла Церква',
    'зарядні станції Бровари',
    'зарядні станції Кременчук',
    'зарядні станції Мелітополь',
    'зарядні станції Бердянськ',
    'зарядні станції Миколаїв',
    'Умань зарядка',
    'Київ зарядка',
    'Харків зарядка',
    'Одеса зарядка',
    'Львів зарядка',
    'Дніпро зарядка',
    'Запоріжжя зарядка',
    'Вінниця зарядка',
    'Полтава зарядка',
    // Highway/Road keywords
    'зарядка на трасі Київ Одеса',
    'зарядка на трасі Київ-Одеса',
    'зарядка на трасі Київ Харків',
    'зарядка на трасі Київ-Харків',
    'зарядка на трасі Київ Львів',
    'зарядка на трасі Київ-Львів',
    'зарядка на трасі Київ Чоп',
    'зарядка на трасі Київ Житомир',
    'зарядка на трасі Харків Дніпро',
    'зарядка на трасі Дніпро Запоріжжя',
    'зарядка на трасі Одеса Миколаїв',
    'зарядка на трасі Львів Ужгород',
    'зарядка на трасі М05',
    'зарядка на трасі М03',
    'зарядка на трасі М06',
    'зарядка на трасі Е40',
    'зарядка на трасі Е95',
    'зарядна станція на трасі',
    'де зарядити на трасі',
    'зарядка на автобані',
    // Action keywords
    'де зарядити електромобіль',
    'найближча зарядна станція',
    'карта зарядних станцій',
    'знайти зарядку',
    'електрозаправка поруч',
    'зарядні станції поруч',
    // Feature keywords
    'швидка зарядка',
    'AC зарядка',
    'DC зарядка',
    'статус зарядних станцій',
    // All operators (like EVBOOST)
    'ECOFACTOR',
    'Flash',
    'Yasno',
    'EVA Chargers',
    'QuickPower',
    'UGV',
    'Ladergy',
    'CloudPay',
    'Chargex',
    'ICar',
    'EVBOOST',
    // Connector types
    'Type2 зарядка',
    'CCS2 зарядка',
    'CHAdeMO',
    'GBT зарядка',
    'NACS',
    'Type2 станції',
    'CCS зарядні станції',
    // Car origin keywords
    'зарядка авто з Китаю',
    'зарядка авто з Європи',
    'зарядка авто з Америки',
    'зарядка BYD',
    'зарядка Tesla',
    'зарядка NIO',
    'зарядка VW ID',
    // Power keywords
    'швидка зарядка 150 кВт',
    'швидка зарядка 350 кВт',
    'суперчарджер',
    // Blackout/Power outage keywords - CRITICAL for Ukraine
    'зарядка при відключенні світла',
    'зарядка в блекаут',
    'зарядка без світла',
    'де є світло зарядка',
    'зарядка коли немає світла',
    'зарядні станції з генератором',
    'де точно є світло',
    'автономні зарядні станції',
    'зарядка при блекауті',
    'станції що працюють без світла',
    'зарядні станції з резервним живленням',
  ].join(', '),
  url: 'https://220-km.com/list',
  image: 'https://220-km.com/logo512.png',
  structuredData: {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    '@id': 'https://220-km.com/list#stationlist',
    name: 'Зарядні станції мережі 220 км',
    description: 'Повний список зарядних станцій для електромобілів мережі 220 км в Україні',
    url: 'https://220-km.com/list',
    numberOfItems: '500+',
    itemListOrder: 'https://schema.org/ItemListOrderDescending',
    provider: {
      '@type': 'Organization',
      name: 'Мережа 220 км',
      url: 'https://220-km.com',
    },
  },
};

// Lazy loading configuration
const PORTS_PER_STEP = 50;
const INITIAL_PORTS_COUNT = 50;
const USE_VIRTUALIZATION_THRESHOLD = 100; // Use virtualization for more than 100 stations

function focusListSearchInput(input) {
  if (!input) return false;
  try {
    input.focus({ preventScroll: true });
  } catch {
    input.focus();
  }
  if (typeof input.setSelectionRange === 'function') {
    const len = input.value.length;
    input.setSelectionRange(len, len);
  }
  return document.activeElement === input;
}

export default function HomeListPage({ fingerPrint }) {
  const { data: bloodyLitters, isLoading: bloodyIsLoading } = useGetBloodyLitersSavedQuery();

  const scrollContainerRef = useRef(null);
  const searchInputRef = useRef(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  /* When on list page, also add list-page-scroll so scroll container ref is used (body already locked by app-scroll-lock). */
  useEffect(() => {
    document.body.classList.add('list-page-scroll');
    return () => document.body.classList.remove('list-page-scroll');
  }, []);

  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const hideListPageSearch = isCapacitorIos();
  const [pendingSearchFocus, setPendingSearchFocus] = useState(
    () => !hideListPageSearch && searchParams.get('focusSearch') === '1'
  );

  const { t } = useTranslation();

  const [searchQuery, setSearchQuery] = useState(() => (hideListPageSearch ? '' : searchParams.get('q') || ''));
  const [searchCatalog, setSearchCatalog] = useState(null);

  useEffect(() => {
    if (hideListPageSearch) {
      const next = new URLSearchParams(searchParams);
      let changed = false;
      if (next.get('focusSearch') === '1') {
        next.delete('focusSearch');
        changed = true;
      }
      if (next.has('q')) {
        next.delete('q');
        changed = true;
      }
      if (changed) {
        setSearchParams(next, { replace: true });
      }
      setPendingSearchFocus(false);
      setSearchQuery('');
      return;
    }
    if (searchParams.get('focusSearch') !== '1') {
      return;
    }
    setPendingSearchFocus(true);
    const next = new URLSearchParams(searchParams);
    next.delete('focusSearch');
    setSearchParams(next, { replace: true });
  }, [hideListPageSearch, searchParams, setSearchParams]);

  const [getStationStatusAll] = api.useLazyGetKm220PortsQuery();
  const [getStationStatusNearest] = api.useLazyGetNearestStationQuery();

  const [isLocation, setIsLocation] = useState(false);
  const [stationsArr, setStationsArr] = useState();

  const [allStationsStatus, setAllStationStatus] = useState(null);
  const [errorAllStationsStatus, setErrorAllStationsStatus] = useState();
  const [setLoadingAllStationsStatus] = useState();

  const [nearestStationsStatus, setNearestStationStatus] = useState(null);
  const [errorNearestStationStatus, setErrorNearestStationStatus] = useState();
  const [loadingNearestStationStatus, setLoadingNearestStationStatus] = useState();

  // Location permission state
  const [locationDenied, setLocationDenied] = useState(false);

  useLayoutEffect(() => {
    if (!pendingSearchFocus) {
      return undefined;
    }

    // Do not focus during the loading spinner — that input remounts after ports load
    // and the keyboard/focus is lost. Wait until stations are ready (or location blocked).
    if (locationDenied) {
      setPendingSearchFocus(false);
      return undefined;
    }
    if (!stationsArr) {
      return undefined;
    }

    let cancelled = false;
    let timeoutId = null;
    let attempt = 0;

    const tryFocus = () => {
      if (cancelled) return;
      if (focusListSearchInput(searchInputRef.current)) {
        setPendingSearchFocus(false);
        return;
      }
      attempt += 1;
      if (attempt < 24) {
        timeoutId = window.setTimeout(tryFocus, 50);
      } else {
        setPendingSearchFocus(false);
      }
    };

    // Let the loaded list tree paint (fixed search field) before focusing
    timeoutId = window.setTimeout(tryFocus, 0);

    return () => {
      cancelled = true;
      if (timeoutId != null) {
        window.clearTimeout(timeoutId);
      }
    };
  }, [pendingSearchFocus, stationsArr, locationDenied]);

  // Lazy loading state
  const [visiblePortsCount, setVisiblePortsCount] = useState(INITIAL_PORTS_COUNT);
  const [isLoadingMore, setIsLoadingMore] = useState(false);

  const getAllStations = async () => {
    if (!allStationsStatus) {
      const { data, isSuccess, isLoading, isError, error } = await getStationStatusAll({
        acdc: 'all',
        freshOnly: false,
        chinaFilter: 'all',
      });
      if (isLoading && !isSuccess && !isError) {
        setLoadingAllStationsStatus(true);
        setLoadingNearestStationStatus(false);
      }
      if (isSuccess && !isError) {
        setAllStationStatus(data);
        setNearestStationStatus(null);
      }
      if (!isSuccess && isError) {
        setErrorAllStationsStatus(error);
        setErrorNearestStationStatus(undefined);
      }
    }
  };
  const getNearestStation = async position => {
    const { data, isSuccess, isLoading, isError, error } = await getStationStatusNearest({
      lat: position.latitude,
      lon: position.longitude,
      top: '',
      distanceM: '',
      fingerPrint,
    });
    if (isLoading && !isSuccess && !isError) {
      setLoadingAllStationsStatus(false);
      setLoadingNearestStationStatus(true);
    }
    if (isSuccess && !isError) {
      setAllStationStatus(null);
      setNearestStationStatus(data);
    }
    if (!isSuccess && isError) {
      setErrorAllStationsStatus(undefined);
      setErrorNearestStationStatus(error);
    }
  };

  function handleGeolocationSuccess(position) {
    getNearestStation(position.coords);
  }

  function handleGeolocationError(error) {
    // Block access if location is not allowed
    setLocationDenied(true);
  }

  function getGeolocation() {
    const position = getCookie('userLocation');
    if (position) {
      getNearestStation(position);
    } else {
      getGeolocationWithPermission(getAllStations, handleGeolocationError, handleGeolocationSuccess);
    }
  }

  useEffect(() => {
    getGeolocation();
  }, []);

  useEffect(() => {
    if (hideListPageSearch) {
      return undefined;
    }
    let cancelled = false;

    async function loadSearchCatalog() {
      try {
        const { data } = await getStationStatusAll({
          acdc: 'all',
          freshOnly: false,
          chinaFilter: 'all',
        });
        if (!cancelled) {
          setSearchCatalog(Array.isArray(data) ? data : []);
        }
      } catch {
        if (!cancelled) {
          setSearchCatalog([]);
        }
      }
    }

    void loadSearchCatalog();

    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hideListPageSearch]);

  const handleSearchQueryChange = useCallback(
    value => {
      setSearchQuery(value);
      const next = new URLSearchParams(searchParams);
      const trimmed = String(value ?? '').trim();
      if (trimmed) {
        next.set('q', trimmed);
      } else {
        next.delete('q');
      }
      setSearchParams(next, { replace: true });
    },
    [searchParams, setSearchParams]
  );

  useEffect(() => {
    if (hideListPageSearch) {
      setSearchQuery('');
      return;
    }
    const q = searchParams.get('q') || '';
    setSearchQuery(prev => (prev.trim() === q ? prev : q));
  }, [hideListPageSearch, searchParams]);

  useEffect(() => {
    if (allStationsStatus && !nearestStationsStatus) {
      console.log('Setting all stations:', allStationsStatus.length);
      setStationsArr(allStationsStatus);
    }
    if (!allStationsStatus && nearestStationsStatus) {
      console.log('Setting nearest stations:', nearestStationsStatus.length);
      setStationsArr(nearestStationsStatus);
    }
  }, [allStationsStatus, nearestStationsStatus]);

  // Filter stations to exclude specific ones
  const filteredStations = useMemo(() => {
    if (!stationsArr) return [];

    const filtered = stationsArr.filter(isKm220ListStation);

    console.log('Filtering stations:', {
      original: stationsArr.length,
      filtered: filtered.length,
      sample: filtered.slice(0, 3).map(s => s.name),
    });

    return filtered;
  }, [stationsArr]);

  const isSearchActive = Boolean(searchQuery.trim());

  const displayStations = useMemo(() => {
    if (isSearchActive) {
      const catalog = (searchCatalog || []).filter(isKm220ListStation);
      return filterStationsBySearch(catalog, searchQuery);
    }
    return filteredStations;
  }, [isSearchActive, searchCatalog, searchQuery, filteredStations]);

  /** Nearest list (geolocation) — first 10 ports for live connector status polling. */
  const isNearestListMode = Boolean(nearestStationsStatus && !allStationsStatus);
  const closestTenStationNumbers = useMemo(() => {
    if (!isNearestListMode || !filteredStations.length) return [];
    return filteredStations
      .slice(0, 10)
      .map(s => s?.number)
      .filter(n => n != null && String(n).trim() !== '')
      .map(n => String(n));
  }, [isNearestListMode, filteredStations]);

  /** Per port: `{ isReady, isOccupied }` from `/v2/device/status`. */
  const [closestPortsDeviceStatus, setClosestPortsDeviceStatus] = useState({});
  const closestTenKey = closestTenStationNumbers.join(',');

  useEffect(() => {
    const nums = closestTenKey ? closestTenKey.split(',') : [];
    if (!nums.length) {
      setClosestPortsDeviceStatus({});
      return undefined;
    }

    let cancelled = false;

    const fetchStatuses = async () => {
      const next = {};
      await Promise.all(
        nums.map(async num => {
          try {
            const r = await fetch(
              `${HOST}:${PORT}/api/device/v2/device/status?station_number=${encodeURIComponent(num)}`
            );
            if (!r.ok || cancelled) return;
            const d = await r.json();
            if (cancelled) return;
            next[num] = {
              isReady: Boolean(d?.isReadyToStart || d?.readyToStart),
              isOccupied: Boolean(d?.isOccupied || d?.occupied),
            };
          } catch {
            /* omit — card falls back to readyForUse */
          }
        })
      );
      if (!cancelled) {
        setClosestPortsDeviceStatus(next);
      }
    };

    void fetchStatuses();
    const id = window.setInterval(() => void fetchStatuses(), 10000);
    return () => {
      cancelled = true;
      window.clearInterval(id);
    };
  }, [closestTenKey, HOST, PORT]);

  // Get visible stations for lazy loading
  const visibleStations = useMemo(() => {
    return displayStations.slice(0, visiblePortsCount);
  }, [displayStations, visiblePortsCount]);

  /** Port count per deviceId from the full list (not only the visible page). */
  const portCountByKey = useMemo(() => {
    const counts = new Map();
    for (const station of displayStations) {
      const deviceKey = station?.deviceId != null ? String(station.deviceId).trim() : '';
      const key = deviceKey || `_port_${station?.number ?? ''}`;
      counts.set(key, (counts.get(key) || 0) + 1);
    }
    return counts;
  }, [displayStations]);

  const getStationPortCount = useCallback(
    station => {
      const deviceKey = station?.deviceId != null ? String(station.deviceId).trim() : '';
      const key = deviceKey || `_port_${station?.number ?? ''}`;
      return portCountByKey.get(key) || 1;
    },
    [portCountByKey]
  );

  // Load more stations function with debouncing
  const loadMoreStations = useCallback(() => {
    if (visiblePortsCount < displayStations.length && !isLoadingMore) {
      setIsLoadingMore(true);

      // Simulate API delay for better UX
      setTimeout(() => {
        const newCount = Math.min(visiblePortsCount + PORTS_PER_STEP, displayStations.length);
        console.log('Loading more stations:', visiblePortsCount, '->', newCount);
        setVisiblePortsCount(newCount);
        setIsLoadingMore(false);

        // Smooth scroll to show new content
        setTimeout(() => {
          const lastStation = document.querySelector(`[data-station-index="${newCount - 1}"]`);
          if (lastStation) {
            lastStation.scrollIntoView({
              behavior: 'smooth',
              block: 'nearest',
            });
          }
        }, 100);
      }, 300); // Small delay to show loading state
    }
  }, [visiblePortsCount, displayStations.length, isLoadingMore]);

  // Debounced version of loadMoreStations
  const debouncedLoadMore = useCallback(() => {
    if (loadMoreStations.currentTimeout) {
      clearTimeout(loadMoreStations.currentTimeout);
    }
    loadMoreStations.currentTimeout = setTimeout(() => {
      loadMoreStations();
    }, 100);
  }, [loadMoreStations]);

  // Intersection Observer for infinite scroll (layoutMainScroll is the only scroller).
  useEffect(() => {
    const root = document.getElementById('layoutMainScroll') || scrollContainerRef.current;
    const observer = new IntersectionObserver(
      entries => {
        const lastEntry = entries[entries.length - 1];
        if (lastEntry.isIntersecting && !isLoadingMore && visiblePortsCount < displayStations.length) {
          console.log('Loading more stations: current', visiblePortsCount, 'of', displayStations.length);
          debouncedLoadMore();
        }
      },
      { threshold: 0.1, rootMargin: '100px', root: root || undefined }
    );

    const sentinel = document.getElementById('scroll-sentinel');

    if (sentinel && root) {
      observer.observe(sentinel);
    }

    return () => {
      if (sentinel) {
        observer.unobserve(sentinel);
      }
    };
  }, [debouncedLoadMore, isLoadingMore, visiblePortsCount, displayStations.length]);

  // Alternative scroll event listener as backup
  useEffect(() => {
    const el = document.getElementById('layoutMainScroll') || scrollContainerRef.current;
    const getScrollValues = () => {
      if (el) {
        return { scrollTop: el.scrollTop, scrollHeight: el.scrollHeight, height: el.clientHeight };
      }
      return {
        scrollTop: window.pageYOffset || document.documentElement.scrollTop,
        scrollHeight: document.documentElement.scrollHeight,
        height: window.innerHeight,
      };
    };
    const handleScroll = () => {
      const { scrollTop, scrollHeight, height } = getScrollValues();
      if (scrollHeight - scrollTop - height < 200) {
        if (!isLoadingMore && visiblePortsCount < displayStations.length) {
          console.log('Loading more via scroll event');
          debouncedLoadMore();
        }
      }
    };

    if (el) {
      el.addEventListener('scroll', handleScroll);
      return () => el.removeEventListener('scroll', handleScroll);
    }
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isLoadingMore, visiblePortsCount, displayStations.length, debouncedLoadMore]);

  // Reset visible ports when stations change
  useEffect(() => {
    setVisiblePortsCount(INITIAL_PORTS_COUNT);
  }, [displayStations]);

  // Debug stationsArr changes
  useEffect(() => {
    console.log('stationsArr changed:', {
      hasData: !!stationsArr,
      length: stationsArr?.length,
      sample: stationsArr?.slice(0, 2)?.map(s => s.name),
    });
  }, [stationsArr]);

  // Determine if we should use virtualization
  const shouldUseVirtualization = false; // Always use fallback mode

  // For virtualization, we need to pass all filtered stations, not just visible ones
  const virtualizationStations = shouldUseVirtualization ? displayStations : [];

  // Always use fallback mode
  const [useFallback, setUseFallback] = useState(true);

  useEffect(() => {
    // Always use fallback mode
    setUseFallback(true);
  }, []);

  // Debug information
  console.log('HomeListPage Debug:', {
    stationsArr: stationsArr?.length,
    filteredStations: filteredStations.length,
    displayStations: displayStations.length,
    visibleStations: visibleStations.length,
    visiblePortsCount,
    isLoadingMore,
  });

  if ((errorNearestStationStatus && errorNearestStationStatus !== 400) || errorAllStationsStatus) {
    return <ErrorPage errorHeader={t('errorDevHeader')} errorBody={t('errorDevBody')} />;
  }
  if (!stationsArr && !locationDenied) {
    if (pendingSearchFocus) {
      return (
        <>
          <SeoHead fallbackTitle="220 km">
            <title>{seoConfig.title}</title>
            <meta name="description" content={seoConfig.description} />
          </SeoHead>
          <div id="homePage" className="listPageRoot">
            {!hideListPageSearch ? (
              <div className="home-list-search-fixed">
                <StationListSearch ref={searchInputRef} value={searchQuery} onChange={handleSearchQueryChange} />
              </div>
            ) : null}
            <div className="home-list-page-head" />
            <div className="home-list-loading">
              <Spinner />
            </div>
          </div>
        </>
      );
    }

    return <Spinner pageCentered />;
  }

  // Show location required message if location permission was denied
  if (locationDenied) {
    return (
      <>
        <SeoHead fallbackTitle="220 km">
          <title>{seoConfig.title}</title>
          <meta name="description" content={seoConfig.description} />
        </SeoHead>
        <div id="homePage" className="listPageRoot listPageRoot--location-denied">
          <div
            style={{
              textAlign: 'center',
              maxWidth: '500px',
              width: '100%',
            }}
          >
            <div style={{ fontSize: '64px', marginBottom: '20px' }}>📍</div>
            <h2
              style={{
                color: 'white',
                fontSize: '24px',
                marginBottom: '16px',
                fontWeight: '500',
              }}
            >
              {t('locationRequired.title')}
            </h2>
            <p
              style={{
                color: 'rgba(255, 255, 255, 0.7)',
                fontSize: '16px',
                lineHeight: '1.5',
                marginBottom: '32px',
              }}
            >
              {t('locationRequired.description')}
            </p>
            <Button
              onClick={() => navigate('/')}
              style={{
                borderRadius: '20px',
                minHeight: '56px',
                width: '86%',
                margin: '0 auto',
              }}
              variant="outline-alt"
            >
              <span
                style={{
                  fontSize: '26px',
                  letterSpacing: '4.3px',
                }}
              >
                {t('locationRequired.goToMap')}
              </span>
            </Button>
          </div>
        </div>
      </>
    );
  }

  function showList() {
    return (
      <>
        {!hideListPageSearch ? (
          <div className="home-list-search-fixed">
            <StationListSearch ref={searchInputRef} value={searchQuery} onChange={handleSearchQueryChange} />
          </div>
        ) : null}
        <div className="home-list-page-head">
          <div className="home-list-impact-wrap">
            {!bloodyIsLoading && <GlobalChargeImpactSummary liters={bloodyLitters} />}
          </div>
          <>
            {!isLocation && !isSearchActive && (
              <>
                {!nearestStationsStatus && (
                  <Box className="home-list-map-link" display="flex" justifyContent="center" alignItems="center">
                    <Button
                      onClick={() => navigate('/')}
                      style={{
                        width: 'auto',
                        height: '47px',
                        padding: '0 14px',
                        fontSize: '20px',
                        fontWeight: '300',
                        letterSpacing: '3px',
                        textTransform: 'uppercase',
                      }}
                      variant="outline-alt"
                    >
                      {t('btns.getNearestStationsStatus')}
                    </Button>
                  </Box>
                )}
              </>
            )}
          </>
        </div>

        <Box id="homePageContainer" className="home-list-stations">
          {isSearchActive && searchCatalog === null ? (
            <Box display="flex" justifyContent="center" sx={{ py: '48px' }}>
              <Spinner />
            </Box>
          ) : displayStations.length > 0 ? (
            <>
              {visibleStations.map((station, index) => (
                <MemoizedStationCard
                  station={station}
                  isFetching={loadingNearestStationStatus}
                  closestPortsDeviceStatus={isNearestListMode ? closestPortsDeviceStatus : undefined}
                  portCount={getStationPortCount(station)}
                  key={`${station.id || station.name || index}-${index}`}
                  data-station-index={index}
                />
              ))}

              {/* Invisible scroll sentinel for automatic loading */}
              <div
                id="scroll-sentinel"
                style={{
                  width: '100%',
                  height: '20px',
                  visibility: 'hidden',
                }}
                data-testid="scroll-sentinel"
              />
            </>
          ) : (
            <Row style={{ backgroundColor: 'transparent' }} className="mainBtn pr-2 pl-2">
              <p
                style={{
                  color: 'inherit',
                  textAlign: 'center',
                  fontSize: '22px',
                }}
                className="mainBtnText mb-3"
              >
                {isSearchActive ? t('stationListSearchNoResults') : t('noNearestStations')}
              </p>
            </Row>
          )}
        </Box>
      </>
    );
  }

  return (
    <>
      <SeoHead fallbackTitle="220 km">
        {/* Primary Meta Tags */}
        <title>{seoConfig.title}</title>
        <meta name="title" content={seoConfig.title} />
        <meta name="description" content={seoConfig.description} />
        <meta name="keywords" content={seoConfig.keywords} />
        <link rel="canonical" href={seoConfig.url} />

        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content={seoConfig.url} />
        <meta property="og:title" content={seoConfig.title} />
        <meta property="og:description" content={seoConfig.description} />
        <meta property="og:image" content={seoConfig.image} />
        <meta property="og:site_name" content="Мережа 220 км" />
        <meta property="og:locale" content="uk_UA" />

        {/* Twitter */}
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:url" content={seoConfig.url} />
        <meta property="twitter:title" content={seoConfig.title} />
        <meta property="twitter:description" content={seoConfig.description} />
        <meta property="twitter:image" content={seoConfig.image} />

        {/* Additional SEO */}
        <meta name="robots" content="index, follow" />

        {/* Structured Data */}
        <script type="application/ld+json">{JSON.stringify(seoConfig.structuredData)}</script>
      </SeoHead>
      <div id="homePage" className="listPageRoot" ref={scrollContainerRef}>
        {showList()}
      </div>
    </>
  );
}
